/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Section_3_TitleInputs */

const en_terms_section_3_title = /** @type {(inputs: Terms_Section_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Services Description`)
};

const lv_terms_section_3_title = /** @type {(inputs: Terms_Section_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3. Pakalpojumu apraksts`)
};

/**
* | output |
* | --- |
* | "3. Services Description" |
*
* @param {Terms_Section_3_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const terms_section_3_title = /** @type {((inputs?: Terms_Section_3_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Section_3_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_terms_section_3_title(inputs)
	return en_terms_section_3_title(inputs)
});